import React from 'react'
import PropTypes from 'prop-types'

import miapp from 'images/landing/china/shared/app-store-links/miapp.png'
import baidu from 'images/landing/china/shared/app-store-links/baidu.png'
import huawei from 'images/landing/china/shared/app-store-links/huawei.png'
import applestore from 'images/landing/china/shared/app-store-links/applestore.png'
import tencent from 'images/landing/china/shared/app-store-links/tencent.png'
import qr from 'images/landing/china/shared/qr.jpg'
import styles from './_appLinks.css'

function AppLinks (props) {
  const { align } = props
  const alignmentClass = align ? `align--${align}` : 'align--left'
  return (
    <div className={`${styles.callToAction} ${styles[alignmentClass]}`}>
      <h3 className={styles.callToActionTitle}>
        下载APP
      </h3>
      <div className={styles.callToActionContent}>
        <div className={styles.callToActionLinks}>
          <div className={styles.androidLinks}>
            <AppLink href='http://app.mi.com/details?id=cn.ua.run' src={miapp} />
            <AppLink href='http://a.app.qq.com/o/simple.jsp?pkgname=cn.ua.run' src={tencent} />
            <AppLink href='http://shouji.baidu.com/software/23405285.html' src={baidu} />
            <AppLink href='http://app.hicloud.com/app/C10818031' src={huawei} />
          </div>
          <div className={styles.appleLink}>
            <AppLink href='https://itunes.apple.com/us/app/ua-run/id1197421099?l=zh&ls=1&mt=8' src={applestore} />
          </div>
        </div>
        <div className={styles.qr}><img src={qr} /></div>
      </div>
    </div>
  )
}

AppLinks.propTypes = {
  align: PropTypes.string,
}

function AppLink (props) {
  const { src, href } = props
  return (
    <a href={href} className={styles.callToActionLink}>
      <img src={src} />
    </a>
  )
}

AppLink.propTypes = {
  src: PropTypes.string,
  href: PropTypes.string,
}

export default AppLinks
